import React from "react";
import { ContentTemplateModel } from "outbound-api-client/lib/models";
import { Content } from "../../../components";
import { configService } from "../../../services";
import { Helmet } from "react-helmet";
import { useCampaignDispatch } from "../../Campaigns/Campaigns.hooks";
import { useAppDispatch } from "../../../store";
import { useParams } from "react-router-dom";
import moment from "moment";


export const ContentTemplate: React.FC<ContentTemplateModel> = ({
  title,
  summary,
  template,
}) => {

  // #region Use CampainId to get metadata for the dynamic content
  // TODO: Campaign data should not be in Content Template; Move dynamic content metadata handling somewhere else

  const appId = process.env.REACT_APP_CLIENTID;
  let replaceableValues: Record<string, string> | null = null;
  const { identifier } = useParams();
  const dispatch = useAppDispatch();
  const { campaign } = useCampaignDispatch(dispatch, identifier || '');

  if (["ricoh-rewards"].includes(appId as string)) {
    const dateExpires = (campaign as { dateExpires?: Date | string | null } | undefined)?.dateExpires;

    if (dateExpires) {
      replaceableValues = {
        daysRemaining: Math.floor(moment.duration(moment(dateExpires).diff(moment())).asDays()).toString(),
        team_totalPoints: "&mdash;",
        team_totalRewards: "&mdash;"
      };

    }
  }
  // #endregion


  return (
    <>
      <Helmet>
        <title>
          {configService.current().applicationTitle}
          {title ? ` - ${title.toString()}` : ""}
        </title>
      </Helmet>
      <div className='p-x-1'>
        {title && <h3 className='font-title text-center'>{title}</h3>}
        <p className='font-subtitle'>{summary}</p>
        <Content template={template} replaceableValues={replaceableValues} />
      </div>
    </>
  )
}